import { createContext, useContext, useState } from "react";

export interface IAuthContext {
  token: string | null;
  setToken: (token: string) => void;
  isLoggedIn: boolean | any;
  setIsLoggedIn: (payload: boolean | any) => void;

  login: (payload: string) => void;
  logout: () => void;
}

const authContext = createContext<IAuthContext>({
  token: null,
  setToken: () => false,
  isLoggedIn: false,
  setIsLoggedIn: () => false,

  login: () => false,
  logout: () => false,
});

export function AuthContextProvider(props: any) {
  const [token, setToken] = useState<null | string>(
    localStorage.getItem("token")
  );
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | any>(
    token ? true : false
  );

  const login = (token: string) => {
    setToken(token);
    setIsLoggedIn(true);
    window.localStorage.setItem("token", token);
  };

  const logout = () => {
    setToken(null);
    setIsLoggedIn(false);
    window.localStorage.removeItem("token");
    localStorage.removeItem("current_workspace");
  };

  return (
    <authContext.Provider
      value={{
        token,
        setToken,
        isLoggedIn,
        setIsLoggedIn,
        login,
        logout,
      }}
      {...props}
    />
  );
}

export const useAuthContext = () => useContext(authContext);
